import IntegrationVideo from '@Web/Pages/Web/Integrations/Components/IntegrationVideo';
import { ZOHO_BLOG, ZOHO_LINKS } from '@Web/Pages/Web/Integrations/constants.jsx';
import UniversalBlog from '@Web/Pages/Web/Integrations/Components/UniversalBlog';
import IntegrationStats from '@Web/Pages/Web/Integrations/Components/Stats';
import PageHeader from '@Web/Pages/Web/Integrations/Components/PageHeader';
import DemoInput from '@Web/Src/UI/DemoInput';
import Layout from '@Web/Pages/Web/Layout';

function Zoho() {
    return (
        <Layout>
            <div className='page-container relative flex flex-col items-center justify-center'>
                <PageHeader
                    icon={'zoho'}
                    name={'Zoho'}
                    videoLink={ZOHO_LINKS.videoLink}
                    appLink={ZOHO_LINKS.appLink}
                    topTitle={true}
                />

                {ZOHO_BLOG.map((item) => {
                    return <UniversalBlog data={item} key={item.img} />;
                })}

                <DemoInput />

                <IntegrationVideo
                    name={'Zoho'}
                    videoImg={'zoho'}
                    videoUrl={ZOHO_LINKS.embedVideoLink}
                />

                <IntegrationStats />
            </div>
        </Layout>
    );
}

export default Zoho;
